import {gotoLoginWithRedirect, gotoRegisterWithRedirect} from '@/helper/url';
import {PATHS} from '@/const/paths';
import {parse} from 'query-string';

const TARGET_KEY = 'phemex_redirect_target';
const TRUSTED_DOMAINS = ['phemex.com', 'localhost'];

function isAuthPage(url: string): boolean {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;

    // 检查是否为登录或注册页面（英文路径或本地化路径）
    const pathSegments = pathname.split('/').filter((segment) => segment);
    const lastSegment = pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : '';

    if (lastSegment === 'login' || lastSegment === 'register' || pathname === PATHS.LOGIN.pathname || pathname === PATHS.REGISTER.pathname) {
      const isEnglishPath = pathname === PATHS.LOGIN.pathname || pathname === PATHS.REGISTER.pathname;
      return true;
    }

    return false;
  } catch {
    return false;
  }
}

export function setRedirectTarget(target: string) {
  if (!target || isAuthPage(target)) {
    return;
  }
  sessionStorage.setItem(TARGET_KEY, target);
}

export function getRedirectTarget(): string | null {
  try {
    const query = parse(window.location.search);
    const queryTarget = query.target as string;

    if (queryTarget) {
      setRedirectTarget(queryTarget);
      return queryTarget;
    }
  } catch (e) {}

  // 如果 URL 中没有 target,则从 sessionStorage 中获取
  const target = sessionStorage.getItem(TARGET_KEY);

  return target;
}

export function clearRedirectTarget() {
  sessionStorage.removeItem(TARGET_KEY);
}

export function isValidRedirectTarget(target: string): boolean {
  if (!target) {
    return false;
  }
  if (target.indexOf('@') > -1) {
    return false;
  }
  try {
    const url = new URL(target);
    const isValid = TRUSTED_DOMAINS.some((domain) => url.hostname.endsWith(domain)) && !isAuthPage(target);

    return isValid;
  } catch (e) {
    return false;
  }
}

export {gotoLoginWithRedirect, gotoRegisterWithRedirect};
